var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "list-box-container",
      class: [
        _vm.job.arrival_window_period === "pm" &&
        _vm.job.cash_collected !== false
          ? "pm-job"
          : "",
        _vm.canShowCashCollect &&
          _vm.job.cash_collected === false &&
          "job-not-cash-collected"
      ],
      attrs: { id: _vm.job.id },
      on: {
        mouseup: function($event) {
          _vm.$_can("jobs.show") || _vm.$_can("jobs.view-own")
        }
      }
    },
    [
      _vm.jobLoading
        ? [_vm._m(0)]
        : [
            _c(
              "router-link",
              {
                staticClass: "job-block-font",
                attrs: {
                  to: {
                    name: "JobsEdit",
                    params: { id: "" + _vm.job.id },
                    query: {
                      q:
                        "" +
                        (_vm.q
                          ? "" + encodeURIComponent(_vm.q.toUpperCase())
                          : "")
                    }
                  }
                }
              },
              [
                _c("div", { staticClass: "d-flex list-box-header col-12" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "list-box-header-left col-xl-5 col-lg-4 col-md-5 col-4"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pl-0 d-flex align-items-center col-xl-7 col-lg-10 col-md-12 col-6 pointer"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-4 list-box-status align-items-start pl-0",
                              on: {
                                mouseover: function($event) {
                                  _vm.visible = true
                                },
                                mouseout: function($event) {
                                  _vm.visible = false
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "pointer d-flex" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "ref-id position-relative pr-2"
                                  },
                                  [
                                    _vm.job.is_flat_rate
                                      ? _c("img", {
                                          staticClass: "flat-rate-indicator",
                                          attrs: {
                                            src: require("../../assets/img/flat-rate-job-icon.svg"),
                                            alt: "Flat rate job icon"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.job.ref_id) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm.visible
                                    ? _c("i", {
                                        staticClass:
                                          "fa fa-copy list-box-icon pointer",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            _vm.copyToClipboard(
                                              _vm.job.ref_id,
                                              "Successfully copied to clipboard"
                                            )
                                          },
                                          mousemove: function($event) {
                                            _vm.visible = true
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.job.status
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex align-items-center"
                                      },
                                      [
                                        _vm.job.status === "Accepted"
                                          ? _c(
                                              "span",
                                              {
                                                class: "btn-status btn-active"
                                              },
                                              [
                                                _vm.job.status.name
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.job.status.name
                                                        )
                                                      )
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(_vm.job.status)
                                                      )
                                                    ])
                                              ]
                                            )
                                          : _vm.job.status === "On Hold"
                                            ? _c(
                                                "span",
                                                {
                                                  class:
                                                    "btn-status btn-rejected"
                                                },
                                                [
                                                  _vm.job.status.name
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.job.status.name
                                                          )
                                                        )
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(_vm.job.status)
                                                        )
                                                      ])
                                                ]
                                              )
                                            : _vm.job.status === "Pending"
                                              ? _c(
                                                  "span",
                                                  {
                                                    class:
                                                      "btn-status btn-pending"
                                                  },
                                                  [
                                                    _vm.job.status.name
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.job.status
                                                                .name
                                                            )
                                                          )
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.job.status
                                                            )
                                                          )
                                                        ])
                                                  ]
                                                )
                                              : _vm.job.status === "Created"
                                                ? _c(
                                                    "span",
                                                    {
                                                      class:
                                                        "btn-status btn-created"
                                                    },
                                                    [
                                                      _vm.job.status.name
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.job.status
                                                                  .name
                                                              )
                                                            )
                                                          ])
                                                        : _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.job.status
                                                              )
                                                            )
                                                          ])
                                                    ]
                                                  )
                                                : _vm.job.status === "Canceled"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        class:
                                                          "btn-status btn-cancelled"
                                                      },
                                                      [
                                                        _vm.job.status.name
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.job.status
                                                                    .name
                                                                )
                                                              )
                                                            ])
                                                          : _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.job.status
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    )
                                                  : _vm.job.status ===
                                                    "Tracking done"
                                                    ? _c(
                                                        "span",
                                                        {
                                                          class:
                                                            "btn-status btn-inprogress"
                                                        },
                                                        [
                                                          _vm.job.status.name
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.job
                                                                      .status
                                                                      .name
                                                                  )
                                                                )
                                                              ])
                                                            : _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.job
                                                                      .status
                                                                  )
                                                                )
                                                              ])
                                                        ]
                                                      )
                                                    : _vm.job.status ===
                                                      "Collect payment"
                                                      ? _c(
                                                          "span",
                                                          {
                                                            class:
                                                              "btn-status btn-inprogress"
                                                          },
                                                          [
                                                            _vm.job.status.name
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.job
                                                                        .status
                                                                        .name
                                                                    )
                                                                  )
                                                                ])
                                                              : _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.job
                                                                        .status
                                                                    )
                                                                  )
                                                                ])
                                                          ]
                                                        )
                                                      : _vm.job.status ===
                                                        "In Progress"
                                                        ? _c(
                                                            "span",
                                                            {
                                                              class:
                                                                "btn-status btn-inprogress"
                                                            },
                                                            [
                                                              _vm.job.status
                                                                .name
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.job
                                                                          .status
                                                                          .name
                                                                      )
                                                                    )
                                                                  ])
                                                                : _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.job
                                                                          .status
                                                                      )
                                                                    )
                                                                  ])
                                                            ]
                                                          )
                                                        : _vm.job.status ===
                                                          "Completed"
                                                          ? _c(
                                                              "span",
                                                              {
                                                                class:
                                                                  "btn-status btn-completed"
                                                              },
                                                              [
                                                                _vm.job.status
                                                                  .name
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm
                                                                            .job
                                                                            .status
                                                                            .name
                                                                        )
                                                                      )
                                                                    ])
                                                                  : _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm
                                                                            .job
                                                                            .status
                                                                        )
                                                                      )
                                                                    ])
                                                              ]
                                                            )
                                                          : _vm.job.status ===
                                                            "Rejected"
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  class:
                                                                    "btn-status btn-rejected"
                                                                },
                                                                [
                                                                  _vm.job.status
                                                                    .name
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .job
                                                                                .status
                                                                                .name
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .job
                                                                                .status
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                ]
                                                              )
                                                            : _c(
                                                                "span",
                                                                {
                                                                  class:
                                                                    "btn-status btn-pending"
                                                                },
                                                                [
                                                                  _vm.job.status
                                                                    .name
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .job
                                                                                .status
                                                                                .name
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .job
                                                                                .status
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                ]
                                                              )
                                      ]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "job-customer col-9 pl-5 d-none d-md-block"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.job.customer))
                                  ]),
                                  _vm._v(" "),
                                  _vm.job.has_subscription
                                    ? _c("span", {
                                        staticClass:
                                          "ml-2 mod-icon-membership d-inline-block",
                                        staticStyle: { "min-width": "20px" }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.job.recurly_subscription_id
                                    ? _c("span", {
                                        staticClass:
                                          "ml-2 mod-icon-recurly-subscription d-inline-block",
                                        staticStyle: { "min-width": "20px" }
                                      })
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center pl-0 col-2 wrap pointer responsive-handle laptop-hidden d-lg-none d-xl-flex"
                        },
                        [
                          _c("div", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.job.carrier_name
                                    ? _vm.job.carrier_name
                                    : "-"
                                ) +
                                "\n            "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("label", {
                        staticClass: "responsive-handle laptop-hidden"
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center col-2 wrap pointer responsive-handle laptop-hidden"
                        },
                        [
                          _c("customTooltip", {
                            attrs: { config: { placement: "top" } },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var isOpen = ref.isOpen
                                  var open = ref.open
                                  var close = ref.close
                                  return _c(
                                    "div",
                                    {
                                      on: { mouseover: open, mouseleave: close }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { attrs: { "data-trigger": "" } },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.job.move_date) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: isOpen,
                                              expression: "isOpen"
                                            }
                                          ],
                                          staticClass: "custom-tooltip",
                                          attrs: { "data-popper": "" }
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "border-black",
                                            attrs: { "x-arrow": "" }
                                          }),
                                          _vm._v(
                                            "\n                  Move date\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center col-2 wrap pointer responsive-handle laptop-hidden ml-1 d-md-none d-xl-flex"
                        },
                        [
                          _c("div", { staticClass: "text-nowrap" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.job.move_size) +
                                "\n            "
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "list-box-header-right col-sm-6 col-xl-6 col-lg-6 col-md-4 col-5"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "cluster-user-username responsive-hidden d-flex align-items-center col-0 col-md-0 col-lg-7 col-xl-8 wrap pointer"
                        },
                        [
                          _c("div", { staticClass: "col-4" }, [
                            _vm.job.arrival_window_from ||
                            _vm.job.arrival_window_to
                              ? _c("span", { staticClass: "mr-3" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.formatTime(
                                          _vm.job.arrival_window_from
                                        )
                                      ) +
                                      " - " +
                                      _vm._s(
                                        _vm.formatTime(
                                          _vm.job.arrival_window_to
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-3 d-flex align-items-center justify-content-center"
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.job.source ? _vm.job.source.name : ""
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-5 d-flex align-items-center justify-content-start flex-wrap ml-3"
                            },
                            _vm._l(_vm.job.tags, function(tag) {
                              return _c("tag-color", {
                                key: tag.id,
                                attrs: {
                                  color: tag.color.name,
                                  name: tag.name,
                                  "input-class": "mr-1"
                                }
                              })
                            })
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "job-trucks-movers d-flex flex-column align-items-center pr-4 wrap pointer col-sm-2 col-xl-2 col-lg-2 col-md-3 col-5 d-md-flex"
                        },
                        [
                          _c("div", { staticClass: "d-flex pl-1" }, [
                            _c("i", {
                              staticClass: "fa fa-user list-box-icon"
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "price-value" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.job.movers) +
                                  "\n              "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "d-flex mt-2" }, [
                            _c("i", {
                              staticClass: "fa fa-truck list-box-icon"
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "price-value" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.job.trucks) +
                                  "\n              "
                              )
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center price wrap pointer col-sm-5 col-7 col-md-2 col-lg-2 col-xl-3 mobile-padding-reset"
                        },
                        [
                          _vm.job.is_flat_rate
                            ? _c("span", { staticClass: "pl-2" }, [
                                _vm._v("$" + _vm._s(_vm.job.price))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.job.is_flat_rate && _vm.job.price_per_hour
                            ? _c("span", { staticClass: "pl-2" }, [
                                _vm._v("$" + _vm._s(_vm.job.price_per_hour))
                              ])
                            : _vm._e()
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "pl-1 pr-md-0 pr-lg-4 ml-md-5 ml-lg-4 options col-3 col-sm-2 col-md-2 col-xl-1 d-flex justify-content-end"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pl-3 pr-md-0 pr-xl-3 options-buttons d-flex justify-content-end"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "dropdown",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                }
                              }
                            },
                            [
                              _c("button", {
                                staticClass: "btn btn-secondary add-filter",
                                attrs: {
                                  type: "button",
                                  id: "dropdownMenuButton",
                                  "data-toggle": "dropdown",
                                  "aria-haspopup": "true",
                                  "aria-expanded": "false"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                  attrs: {
                                    "aria-labelledby": "dropdownMenuButton"
                                  }
                                },
                                [
                                  _vm.canShowCashCollect &&
                                  _vm.job.cash_collected !== null &&
                                  _vm.$_can("jobs.set-cash-collected")
                                    ? [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "dropdown-item nav-link btn",
                                            on: {
                                              click: function($event) {
                                                _vm.cashCollectModal = true
                                              }
                                            }
                                          },
                                          [
                                            !_vm.job.cash_collected
                                              ? [
                                                  _vm._v(
                                                    "\n                      Cash collect\n                    "
                                                  )
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                      Cash not collected\n                    "
                                                  )
                                                ]
                                          ],
                                          2
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.job.status_id !== 16
                                    ? [
                                        !_vm.job.carrier_name ||
                                        _vm.job.status_id === 31
                                          ? [
                                              _vm.$_can("jobs.carrier.assign")
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "dropdown-item nav-link btn",
                                                      on: {
                                                        click:
                                                          _vm.reassignCarrierModal
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Assign carrier\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.job.status_id !== 30 &&
                                              _vm.$_can("jobs.status.update")
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "dropdown-item nav-link btn",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.showModalCancelJob = true
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Cancel\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          : [
                                              _vm.job.status_id === 2
                                                ? [
                                                    _vm.job.status_id !== 31 &&
                                                    _vm.$_can(
                                                      "jobs.status.update"
                                                    )
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "dropdown-item nav-link btn",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.showModalAcceptJob = true
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        Accept\n                      "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.job.status_id !== 31 &&
                                                    _vm.$_can(
                                                      "jobs.status.update"
                                                    )
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "dropdown-item nav-link btn",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.showModalRejectJob = true
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        Reject\n                      "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.job.status_id !== 30 &&
                                                    _vm.$_can(
                                                      "jobs.status.update"
                                                    )
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "dropdown-item nav-link btn",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.showModalCancelJob = true
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        Cancel\n                      "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.job.status_id === 3
                                                ? [
                                                    _vm.$_can(
                                                      "jobs.status.update"
                                                    )
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "dropdown-item nav-link btn",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.changeStatus(
                                                                  _vm.job.id,
                                                                  40
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        In progress\n                      "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "dropdown-item nav-link btn",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.showModalIsSmallJob = true
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        Change job size\n                      "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.job.status_id !== 30 &&
                                                    _vm.$_can(
                                                      "jobs.status.update"
                                                    )
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "dropdown-item nav-link btn",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.showModalCancelJob = true
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        Cancel\n                      "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                : _vm._e()
                                            ],
                                        _vm._v(" "),
                                        (_vm.job.status_id === 1 ||
                                          _vm.job.status_id === 2 ||
                                          _vm.job.status_id === 3 ||
                                          _vm.job.status_id === 31) &&
                                        _vm.job.status_id !== 21 &&
                                        _vm.$_can("jobs.status.update")
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "dropdown-item nav-link btn",
                                                on: {
                                                  click: function($event) {
                                                    _vm.changeStatus(
                                                      _vm.job.id,
                                                      21
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    On Hold\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        (_vm.job.status_id === 30 ||
                                          _vm.job.status_id === 21) &&
                                        _vm.$_can("jobs.status.update")
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "dropdown-item nav-link btn",
                                                on: {
                                                  click: function($event) {
                                                    _vm.restoreStatus()
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Restore\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.$_can("jobs.assign")
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "dropdown-item nav-link btn",
                                                on: {
                                                  click: _vm.reassignUserModal
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Assign user\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.$_can("jobs.carrier.assign") &&
                                        _vm.job.status_id !== 16 &&
                                        _vm.job.status_id !== 30 &&
                                        _vm.job.status_id !== 31 &&
                                        _vm.job.carrier_name
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "dropdown-item nav-link btn",
                                                on: {
                                                  click:
                                                    _vm.reassignCarrierModal
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Assign carrier\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.job.status_id === 31 &&
                                        _vm.$_can("jobs.status.update")
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "dropdown-item nav-link btn",
                                                on: {
                                                  click: function($event) {
                                                    _vm.changeStatus(
                                                      _vm.job.id,
                                                      2
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Return To Pending\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-secondary expand-jobs mobile-hidden",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  _vm.toggleJob(_vm.job.id)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-caret-down caret",
                                class: {
                                  rotate: _vm.expanded.includes(_vm.job.id)
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("hr", {
              class: [
                _vm.expanded.includes(_vm.job.id) ? "w-100 divider" : "hidden"
              ]
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex flex-column job-block-font",
                class: [
                  _vm.expanded.includes(_vm.job.id)
                    ? "list-box-expanded"
                    : "hidden"
                ]
              },
              [
                _c("div", { staticClass: "d-flex col-12 p-0" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-5 d-flex" }, [
                    _vm.showCustomerInfo && _vm.job.customer_email
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "contact-info-wrapper d-flex flex-column justify-content-start col-lg-5 col-0 pl-0 pr-0"
                          },
                          [
                            _c("div", { staticClass: "contact-info mb-4" }, [
                              _c("span", { staticClass: "job-heading pb-3" }, [
                                _vm._v(
                                  "\n                Contact info\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "email" }, [
                                _c("i", {
                                  staticClass: "fa fa-at list-box-icon"
                                }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.job.customer_email) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.job.customer_phone
                                ? _c("span", { staticClass: "phone" }, [
                                    _c("i", {
                                      staticClass: "fa fa-phone list-box-icon"
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.phoneMask.maskedPhone(
                                            _vm.job.customer_phone.replace(
                                              "+1",
                                              ""
                                            )
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column justify-content-start col-lg-7 col-md-12 col-12 pl-0"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "job-heading",
                            staticStyle: { "font-size": "1rem" }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.job.customer) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.showAllAddresses
                          ? _c("div", { staticClass: "circles-wrap" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-column justify-content-between mt-3"
                                },
                                [
                                  _c("div", { staticClass: "d-flex mb-25px" }, [
                                    _c("i", {
                                      staticClass: "fa fa-circle c-pickup",
                                      class: [
                                        _vm.job.addresses[0].type.name ===
                                        "Pickup"
                                          ? "c-pickup"
                                          : "c-delivery d-flex align-items-center"
                                      ]
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "d-flex flex-column address-text"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.job.addresses[0].full_address
                                            ) +
                                            "\n                    "
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center pt-3"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "apt-floor" },
                                              [
                                                _vm._v(
                                                  "Apt: " +
                                                    _vm._s(
                                                      _vm.job.addresses[0]
                                                        .apartment
                                                        ? _vm.job.addresses[0]
                                                            .apartment
                                                        : "-"
                                                    )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "apt-floor pl-4" },
                                              [
                                                _vm._v(
                                                  "Floor: " +
                                                    _vm._s(
                                                      _vm.job.addresses[0].floor
                                                        ? _vm.job.addresses[0]
                                                            .floor
                                                        : "-"
                                                    )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.job.addresses.length > 2
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "remaining-addresses",
                                      attrs: { "data-trigger": "" },
                                      on: {
                                        click: function($event) {
                                          _vm.showAllAddresses = !_vm.showAllAddresses
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            parseInt(_vm.job.addresses.length) -
                                              2
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-column justify-content-between mt-3"
                                },
                                [
                                  _c("div", { staticClass: "d-flex mb-4" }, [
                                    _c("i", {
                                      staticClass: "fa fa-circle c-pickup",
                                      class: [
                                        _vm.job.addresses[
                                          _vm.job.addresses.length - 1
                                        ].type.name === "Pickup"
                                          ? "c-pickup"
                                          : "c-delivery",
                                        _vm.job.addresses[
                                          _vm.job.addresses.length - 1
                                        ].apartment ||
                                        _vm.job.addresses[
                                          _vm.job.addresses.length - 1
                                        ].floor
                                          ? "fa-circle-with-apt"
                                          : "fa-circle"
                                      ]
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "d-flex flex-column address-text"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.job.addresses[
                                                _vm.job.addresses.length - 1
                                              ].full_address
                                            ) +
                                            "\n                    "
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center pt-3"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "apt-floor" },
                                              [
                                                _vm._v(
                                                  "Apt: " +
                                                    _vm._s(
                                                      _vm.job.addresses[
                                                        _vm.job.addresses
                                                          .length - 1
                                                      ].apartment
                                                        ? _vm.job.addresses[
                                                            _vm.job.addresses
                                                              .length - 1
                                                          ].apartment
                                                        : "-"
                                                    )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "apt-floor pl-4" },
                                              [
                                                _vm._v(
                                                  "Floor: " +
                                                    _vm._s(
                                                      _vm.job.addresses[
                                                        _vm.job.addresses
                                                          .length - 1
                                                      ].floor
                                                        ? _vm.job.addresses[
                                                            _vm.job.addresses
                                                              .length - 1
                                                          ].floor
                                                        : "-"
                                                    )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ])
                          : _c(
                              "div",
                              { staticClass: "circles-wrap" },
                              _vm._l(_vm.job.addresses, function(address) {
                                return _c(
                                  "div",
                                  {
                                    key: address.id,
                                    staticClass:
                                      "d-flex flex-column justify-content-between",
                                    class: {
                                      "mt-3": address.type.name === "Pickup"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex mb-25px" },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-circle",
                                          class: [
                                            address.type.name === "Pickup"
                                              ? "c-pickup"
                                              : "c-delivery d-flex align-items-center"
                                          ],
                                          on: {
                                            click: function($event) {
                                              _vm.showAllAddresses = !_vm.showAllAddresses
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-flex flex-column address-text"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(address.full_address) +
                                                "\n                    "
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center pt-3"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "apt-floor" },
                                                  [
                                                    _vm._v(
                                                      "Apt: " +
                                                        _vm._s(
                                                          address.apartment
                                                            ? address.apartment
                                                            : "-"
                                                        )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "apt-floor pl-4"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Floor: " +
                                                        _vm._s(
                                                          address.floor
                                                            ? address.floor
                                                            : "-"
                                                        )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              })
                            )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 d-flex pr-0" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column justify-content-start col-lg-5 responsive-handle"
                      },
                      [
                        _c("div", { staticClass: "list-box-info mb-4" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-wrap justify-content-between",
                              staticStyle: { gap: "10px" }
                            },
                            [
                              _c("div", { staticClass: "d-flex flex-column" }, [
                                _c(
                                  "span",
                                  { staticClass: "job-heading pb-3" },
                                  [
                                    _vm._v(
                                      "\n                    Company\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "pb-3" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.job.company) +
                                      "\n                  "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "job-heading pb-3" },
                                      [
                                        _vm._v(
                                          "\n                      Assigned to\n                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "pb-3" },
                                      [
                                        _c("customTooltip", {
                                          attrs: {
                                            config: { placement: "top" }
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var isOpen = ref.isOpen
                                                var open = ref.open
                                                var close = ref.close
                                                return _c(
                                                  "div",
                                                  {
                                                    on: {
                                                      mouseover: open,
                                                      mouseleave: close
                                                    }
                                                  },
                                                  [
                                                    _vm.job.username
                                                      ? _c(
                                                          "div",
                                                          {
                                                            attrs: {
                                                              "data-trigger": ""
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            " +
                                                                _vm._s(
                                                                  _vm.job
                                                                    .username
                                                                ) +
                                                                "\n                          "
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex",
                                                            attrs: {
                                                              "data-trigger": ""
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-exclamation-circle unassigned-icon"
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "ml-1"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              Unassigned\n                            "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value: isOpen,
                                                            expression: "isOpen"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "custom-tooltip",
                                                        attrs: {
                                                          "data-popper": ""
                                                        }
                                                      },
                                                      [
                                                        _c("div", {
                                                          staticClass:
                                                            "border-black",
                                                          attrs: {
                                                            "x-arrow": ""
                                                          }
                                                        }),
                                                        _vm._v(
                                                          "\n                            Assignee\n                          "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            }
                                          ])
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "job-heading pb-3" }, [
                            _vm._v(
                              "\n                Created at\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "pb-3" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.job.created_at) +
                                "\n              "
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "p-0 d-flex flex-column justify-content-start d-lg-none col-md-7 col-6 hidden-mobile"
                      },
                      [
                        _vm.job.tags && _vm.job.tags.length > 0
                          ? [
                              _c("span", { staticClass: "job-heading pb-2" }, [
                                _vm._v("\n                Tags\n              ")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-start flex-wrap"
                                },
                                _vm._l(_vm.job.tags, function(tag) {
                                  return _c("tag-color", {
                                    key: tag.id,
                                    attrs: {
                                      color: tag.color.name,
                                      name: tag.name,
                                      "input-class": "mr-1"
                                    }
                                  })
                                })
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-end col-lg-4 col-md-4 col-2 responsive-handle"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex flex-column align-items-center"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary pull-right",
                                attrs: {
                                  disabled:
                                    _vm.canLeaveNote ||
                                    !_vm.userHasAccessToCarrier
                                },
                                on: {
                                  click: function($event) {
                                    _vm.showModalCustomerNote = !_vm.showModalCustomerNote
                                  }
                                }
                              },
                              [
                                _vm.job.customer_note
                                  ? [_vm._v("View note")]
                                  : [_vm._v("Add note")]
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa text-secondary",
                              class: _vm.showModalCustomerNote
                                ? "fa fa-caret-up"
                                : "fa fa-caret-down",
                              attrs: { "aria-hidden": "true" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _vm.showModalCustomerNote
                          ? _c("customer-note", {
                              attrs: {
                                "customer-note": _vm.job.customer_note
                                  ? _vm.job.customer_note.note
                                  : "",
                                model: "jobs",
                                "model-id": _vm.job.id,
                                "note-id": _vm.job.customer_note
                                  ? _vm.job.customer_note.id
                                  : null,
                                "user-id": _vm.user.id,
                                "status-name": _vm.job.status
                              },
                              on: {
                                close: function($event) {
                                  _vm.showModalCustomerNote = !_vm.showModalCustomerNote
                                },
                                ok: _vm.saveCustomerNote
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: "customer" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column justify-content-start col-lg-3 col-md-5 col-12 pr-0"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              " md-flex flex-row justify-content-end list-box-info mb-4"
                          },
                          [
                            _vm.job.is_small
                              ? _c(
                                  "div",
                                  { staticClass: "small-job pr-3 pl-3" },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "24",
                                          height: "18",
                                          viewBox: "0 0 24 18",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg"
                                        }
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d:
                                              "M11.2288 4.66967L3.84519 10.7715V17.3571C3.84519 17.5276 3.91269 17.6911 4.03286 17.8117C4.15303 17.9323 4.31601 18 4.48595 18L8.9737 17.9883C9.14309 17.9875 9.30525 17.9194 9.42472 17.7989C9.5442 17.6784 9.61126 17.5154 9.61126 17.3454V13.4995C9.61126 13.329 9.67877 13.1655 9.79894 13.0449C9.9191 12.9243 10.0821 12.8566 10.252 12.8566H12.8151C12.985 12.8566 13.148 12.9243 13.2682 13.0449C13.3883 13.1655 13.4558 13.329 13.4558 13.4995V17.3426C13.4556 17.4272 13.472 17.511 13.504 17.5893C13.5361 17.6675 13.5833 17.7386 13.6428 17.7985C13.7023 17.8584 13.7731 17.906 13.8509 17.9384C13.9288 17.9708 14.0123 17.9875 14.0966 17.9875L18.5828 18C18.7527 18 18.9157 17.9323 19.0359 17.8117C19.156 17.6911 19.2235 17.5276 19.2235 17.3571V10.7671L11.8415 4.66967C11.7547 4.59948 11.6466 4.56121 11.5352 4.56121C11.4237 4.56121 11.3156 4.59948 11.2288 4.66967ZM22.8919 8.81697L19.5439 6.04795V0.482197C19.5439 0.35431 19.4933 0.231662 19.4032 0.141232C19.313 0.0508028 19.1908 0 19.0633 0H16.8207C16.6932 0 16.571 0.0508028 16.4808 0.141232C16.3907 0.231662 16.3401 0.35431 16.3401 0.482197V3.39989L12.7546 0.440004C12.4105 0.155902 11.9788 0.000567925 11.5332 0.000567925C11.0875 0.000567925 10.6558 0.155902 10.3117 0.440004L0.174407 8.81697C0.125744 8.85732 0.0854835 8.90691 0.0559251 8.96288C0.0263666 9.01886 0.00808995 9.08013 0.00213941 9.14319C-0.00381113 9.20626 0.00268106 9.26988 0.021245 9.33043C0.039809 9.39097 0.0700809 9.44726 0.110331 9.49606L1.13155 10.7417C1.17169 10.7907 1.22106 10.8313 1.27684 10.8611C1.33262 10.8909 1.39371 10.9093 1.45661 10.9154C1.51952 10.9215 1.583 10.9151 1.64342 10.8965C1.70385 10.878 1.76003 10.8476 1.80876 10.8072L11.2288 3.02217C11.3156 2.95198 11.4237 2.9137 11.5352 2.9137C11.6466 2.9137 11.7547 2.95198 11.8415 3.02217L21.262 10.8072C21.3106 10.8476 21.3667 10.878 21.427 10.8966C21.4874 10.9152 21.5508 10.9218 21.6136 10.9158C21.6765 10.9098 21.7376 10.8915 21.7933 10.8618C21.8491 10.8322 21.8985 10.7918 21.9388 10.7429L22.96 9.49726C23.0002 9.44818 23.0303 9.39161 23.0487 9.3308C23.067 9.26998 23.0732 9.20613 23.0669 9.14291C23.0606 9.0797 23.0418 9.01836 23.0118 8.96242C22.9818 8.90648 22.941 8.85705 22.8919 8.81697Z",
                                            fill: "#FFAB00"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "movers-number d-flex flex-column pl-2 pr-3"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "movers btn-status mb-1",
                                    class: [
                                      _vm.job.movers ===
                                      _vm.job.assigned_movers.length
                                        ? "turquoise-border-text"
                                        : "orange-yellow-border-text",
                                      _vm.job.assigned_movers.length === 0
                                        ? "red-border-text"
                                        : ""
                                    ],
                                    on: {
                                      click: function($event) {
                                        if (
                                          $event.target !== $event.currentTarget
                                        ) {
                                          return null
                                        }
                                        _vm.showMoversTooltip(
                                          !_vm.showMovers.showTooltip
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm.job.assigned_movers.length
                                      ? _c(
                                          "span",
                                          {
                                            on: {
                                              click: function($event) {
                                                if (
                                                  $event.target !==
                                                  $event.currentTarget
                                                ) {
                                                  return null
                                                }
                                                _vm.showMoversTooltip(
                                                  !_vm.showMovers.showTooltip
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.job.assigned_movers.length
                                                ) +
                                                "/" +
                                                _vm._s(_vm.job.movers) +
                                                "\n\n                    "
                                            ),
                                            _vm.showMovers.showTooltip &&
                                            _vm.job.assigned_movers
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "popover show-movers-popover"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "w-100 d-flex align-items-center justify-content-end"
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass:
                                                            "mod-icon mod-icon-close",
                                                          staticStyle: {
                                                            width: "10px",
                                                            height: "10px"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target !==
                                                                $event.currentTarget
                                                              ) {
                                                                return null
                                                              }
                                                              return _vm.hideMoversTooltip(
                                                                $event
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.job.assigned_movers,
                                                      function(mover, ind) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: mover.id,
                                                            staticClass:
                                                              "d-flex justify-content-between align-items-center mb-1"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "justify-content-center",
                                                                class: [
                                                                  ind + 1 ===
                                                                  _vm.job
                                                                    .assigned_movers
                                                                    .length
                                                                    ? "d-flex align-items-center mb-0"
                                                                    : "d-flex align-items-center"
                                                                ]
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      mover.name
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                                mover.foreman
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "btn-status btn-created ml-1"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "F"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            mover.confirmed ===
                                                            "pending"
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "message-status message-pending"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "send-to-all"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "A"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "message-text message-pending-text"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Pending"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            mover.confirmed ===
                                                            "declined"
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "message-status message-declined"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "send-to-all"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "A"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "message-text message-text"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Declined"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            mover.confirmed ===
                                                            "confirmed"
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "message-status message-confirmed"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "send-to-all"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "A"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "message-text message-text"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Confirmed"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.job.assigned_movers.length
                                              ) +
                                              "/" +
                                              _vm._s(_vm.job.movers) +
                                              "\n                  "
                                          )
                                        ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "trucks btn-status",
                                    class: [
                                      _vm.job.trucks ===
                                      _vm.job.assigned_trucks.length
                                        ? "turquoise-border-text"
                                        : "orange-yellow-border-text",
                                      _vm.job.assigned_trucks.length === 0
                                        ? "red-border-text"
                                        : ""
                                    ],
                                    on: {
                                      click: function($event) {
                                        if (
                                          $event.target !== $event.currentTarget
                                        ) {
                                          return null
                                        }
                                        _vm.showTrucksTooltip(!_vm.showTrucks)
                                      }
                                    }
                                  },
                                  [
                                    _vm.job.assigned_trucks.length
                                      ? _c(
                                          "span",
                                          {
                                            on: {
                                              click: function($event) {
                                                if (
                                                  $event.target !==
                                                  $event.currentTarget
                                                ) {
                                                  return null
                                                }
                                                _vm.showTrucksTooltip(
                                                  !_vm.showTrucks
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.job.assigned_trucks.length
                                                ) +
                                                "/" +
                                                _vm._s(_vm.job.trucks) +
                                                "\n                    "
                                            ),
                                            _vm.job.assigned_trucks &&
                                            _vm.showTrucks
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "popover show-trucks-popover"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "w-100 d-flex align-items-center justify-content-end"
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass:
                                                            "mod-icon mod-icon-close",
                                                          staticStyle: {
                                                            width: "10px",
                                                            height: "10px"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target !==
                                                                $event.currentTarget
                                                              ) {
                                                                return null
                                                              }
                                                              return _vm.hideTrucksTooltip(
                                                                $event
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.job.assigned_trucks,
                                                      function(truck, ind) {
                                                        return _c(
                                                          "div",
                                                          { key: truck.id },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                class: [
                                                                  ind + 1 ===
                                                                  _vm.job
                                                                    .assigned_trucks
                                                                    .length
                                                                    ? "mb-0"
                                                                    : "mb-2"
                                                                ]
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      truck.name
                                                                    ) +
                                                                    "\n                        "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.job.assigned_trucks.length
                                              ) +
                                              "/" +
                                              _vm._s(_vm.job.trucks) +
                                              "\n                  "
                                          )
                                        ])
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex col-12 p-0 d-lg-none d-xl-none" },
                  [
                    _c("div", { staticClass: "col-lg-6 col-md-5 d-flex" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column justify-content-start col-lg-7 col-md-12 col-12 pl-0"
                        },
                        [
                          _c("span", { staticClass: "job-heading" }, [
                            _vm._v("\n              Assigned to\n            ")
                          ]),
                          _vm._v(" "),
                          _vm.job.username
                            ? _c("span", { staticClass: "pb-3 pt-8px" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.job.username) +
                                    "\n            "
                                )
                              ])
                            : _c("span", { staticClass: "pb-3 pt-8px" }, [
                                _c("i", {
                                  staticClass:
                                    "fa fa-exclamation-circle unassigned-icon"
                                }),
                                _vm._v(
                                  "\n              Unassigned\n            "
                                )
                              ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-lg-6 d-flex pr-0" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column justify-content-start col-lg-7 col-md-12 col-12 pl-0"
                        },
                        [
                          _c("span", { staticClass: "job-heading" }, [
                            _vm._v("\n              Move date\n            ")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "pb-3 pt-8px" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.job.move_date) +
                                "\n            "
                            )
                          ])
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex col-12 p-0 d-lg-none d-xl-none" },
                  [
                    _c("div", { staticClass: "col-lg-6 col-md-5 d-flex" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column justify-content-start col-lg-7 col-md-12 col-12 pl-0"
                        },
                        [
                          _c("span", { staticClass: "job-heading" }, [
                            _vm._v("\n              Company\n            ")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "pb-3 pt-8px" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.job.company) +
                                "\n            "
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-lg-6 d-flex pr-0" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column justify-content-start col-lg-7 col-md-12 col-12 pl-0"
                        },
                        [
                          _c("span", { staticClass: "job-heading" }, [
                            _vm._v(
                              "\n              Arrival window\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _vm.job.arrival_window_from ||
                          _vm.job.arrival_window_to
                            ? _c("span", { staticClass: "pb-3 pt-8px" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.formatTime(
                                        _vm.job.arrival_window_from
                                      )
                                    ) +
                                    " - " +
                                    _vm._s(
                                      _vm.formatTime(_vm.job.arrival_window_to)
                                    ) +
                                    "\n            "
                                )
                              ])
                            : _c("span", { staticClass: "pb-3 pt-8px" }, [
                                _vm._v("\n              -\n            ")
                              ])
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start col-12 p-0 responsive-handle"
                  },
                  [
                    _vm.isCompletedOrCanceled && !_vm.job.claim
                      ? _c("div", {
                          staticClass: "d-flex justify-content-start col-6"
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isCompletedOrCanceled && _vm.job.claim
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-content-start col-6" },
                          [
                            _vm.isCompletedOrCanceled &&
                            _vm.job.claim &&
                            _vm.job.claim.claim_status_id !== 3
                              ? _c(
                                  "div",
                                  { staticClass: "claim-unresolved col-12" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center justify-content-between h-100"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center w-100"
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  width: "32",
                                                  height: "25",
                                                  viewBox: "0 0 32 25",
                                                  fill: "none",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    "fill-rule": "evenodd",
                                                    "clip-rule": "evenodd",
                                                    d:
                                                      "M8 14.9381C6.89543 14.9381 6 15.8336 6 16.9381V18.9257C6 20.0303 6.89543 20.9257 8 20.9257H18.0224C18.0076 20.7614 18 20.595 18 20.4268C18 17.3955 20.4624 14.9381 23.5 14.9381C23.7284 14.9381 23.968 14.9403 24.2115 14.9492C24.142 14.9419 24.0714 14.9381 24 14.9381H23.5H8Z",
                                                    fill: "#F57483"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("rect", {
                                                  attrs: {
                                                    x: "6.5",
                                                    y: "8.45259",
                                                    width: "19",
                                                    height: "4.98761",
                                                    rx: "1.5",
                                                    stroke: "#F57483"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("rect", {
                                                  attrs: {
                                                    x: "6.5",
                                                    y: "1.46704",
                                                    width: "19",
                                                    height: "4.98761",
                                                    rx: "1.5",
                                                    stroke: "#F57483"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    "fill-rule": "evenodd",
                                                    "clip-rule": "evenodd",
                                                    d:
                                                      "M23.5 15.9361C21.0187 15.9361 19 17.9506 19 20.4268C19 22.9029 21.0187 24.9175 23.5 24.9175C25.9813 24.9175 28 22.903 28 20.4268C28 17.9506 25.9813 15.9361 23.5 15.9361ZM22.8066 18.6744C22.8066 18.2922 23.1171 17.9824 23.5 17.9824C23.883 17.9824 24.1934 18.2922 24.1934 18.6744V20.4268C24.1934 20.809 23.883 21.1188 23.5 21.1188C23.1171 21.1188 22.8066 20.809 22.8066 20.4268V18.6744ZM24.1797 22.3935C24.1844 22.3713 24.1875 22.3487 24.1898 22.3261C24.1922 22.3035 24.1936 22.2809 24.1936 22.2583C24.1936 22.2357 24.1922 22.2127 24.1899 22.1901C24.1876 22.1679 24.1844 22.1453 24.1797 22.1232C24.1756 22.1011 24.1696 22.0789 24.1631 22.0572C24.1567 22.036 24.1488 22.0144 24.1405 21.9936C24.1317 21.9728 24.1219 21.9521 24.1114 21.9322C24.1007 21.9124 24.0892 21.893 24.0767 21.8741C24.0642 21.8552 24.0504 21.8367 24.036 21.8197C24.0217 21.8022 24.0065 21.7851 23.9903 21.7689C23.9746 21.7532 23.9575 21.7376 23.9399 21.7233C23.9223 21.709 23.9038 21.6956 23.8849 21.6831C23.8663 21.6707 23.8465 21.6587 23.8266 21.6481C23.8067 21.6375 23.7859 21.6278 23.7651 21.6195C23.7443 21.6107 23.7231 21.6029 23.7014 21.5964C23.6796 21.59 23.6579 21.5844 23.6357 21.5798C23.6135 21.5752 23.5908 21.5719 23.5682 21.5696C23.5229 21.565 23.4771 21.565 23.4319 21.5696C23.4097 21.572 23.3871 21.5752 23.3648 21.5798C23.3426 21.5844 23.3205 21.59 23.2987 21.5964C23.277 21.6029 23.2557 21.6107 23.235 21.6195C23.2141 21.6278 23.1933 21.6374 23.1735 21.6481C23.1535 21.6587 23.1341 21.6707 23.1152 21.6831C23.0963 21.6956 23.0777 21.709 23.0606 21.7233C23.0426 21.7375 23.026 21.7532 23.0098 21.7689C22.9936 21.785 22.9784 21.8021 22.964 21.8197C22.9497 21.8367 22.9363 21.8552 22.9238 21.8741C22.9108 21.893 22.8992 21.9124 22.8887 21.9322C22.878 21.9521 22.8683 21.9728 22.86 21.9936C22.8513 22.0144 22.8434 22.036 22.8369 22.0572C22.8305 22.0789 22.8249 22.1011 22.8203 22.1232C22.8156 22.1453 22.8124 22.1679 22.8101 22.1901C22.8078 22.2127 22.8068 22.2357 22.8068 22.2583C22.8068 22.2809 22.8077 22.3035 22.8101 22.3261C22.8124 22.3487 22.8156 22.3713 22.8203 22.3935C22.8249 22.4156 22.8305 22.4378 22.8369 22.459C22.8434 22.4807 22.8513 22.5019 22.86 22.5226C22.8683 22.5434 22.878 22.5642 22.8887 22.584C22.8993 22.6038 22.9108 22.6237 22.9238 22.6421C22.9363 22.661 22.9496 22.6795 22.964 22.697C22.9783 22.7145 22.9935 22.7316 23.0098 22.7473C23.0259 22.7635 23.0426 22.7786 23.0606 22.7934C23.0777 22.8073 23.0963 22.8211 23.1152 22.8336C23.1341 22.846 23.1535 22.8575 23.1735 22.8682C23.1933 22.8788 23.2141 22.8885 23.235 22.8972C23.2557 22.906 23.277 22.9134 23.2987 22.9198C23.3205 22.9268 23.3426 22.9323 23.3648 22.9364C23.387 22.9411 23.4097 22.9448 23.4319 22.9466C23.4545 22.9489 23.4776 22.9503 23.5002 22.9503C23.5229 22.9503 23.5455 22.9489 23.5682 22.9466C23.5908 22.9447 23.6135 22.941 23.6357 22.9364C23.6579 22.9323 23.6795 22.9267 23.7013 22.9198C23.723 22.9134 23.7443 22.906 23.7651 22.8972C23.7859 22.8885 23.8067 22.8788 23.8266 22.8682C23.8465 22.8575 23.8663 22.846 23.8848 22.8336C23.9038 22.8211 23.9222 22.8073 23.9399 22.7934C23.9574 22.7787 23.9745 22.7635 23.9902 22.7473C24.0064 22.7317 24.0216 22.7146 24.0359 22.697C24.0503 22.6795 24.0641 22.661 24.0767 22.6421C24.0892 22.6237 24.1007 22.6038 24.1113 22.584C24.1219 22.5642 24.1317 22.5434 24.1404 22.5226C24.1487 22.5019 24.1566 22.4807 24.163 22.459C24.1695 22.4378 24.1755 22.4156 24.1797 22.3935Z",
                                                    fill: "#F57483"
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "pl-3 claim-unresolved-title"
                                              },
                                              [
                                                _vm._v(
                                                  "Unresolved claim - " +
                                                    _vm._s(_vm.job.claim.title)
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: {
                                                path:
                                                  "/claims/edit/" +
                                                  _vm.job.claim.id
                                              },
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex pointer align-items-center justify-content-end"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "see-claim-unresolved"
                                                  },
                                                  [_vm._v("See claim")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "svg",
                                                  {
                                                    staticClass:
                                                      "claim-unresolved-icon pl-2",
                                                    attrs: {
                                                      width: "24",
                                                      height: "25",
                                                      viewBox: "0 0 24 25",
                                                      fill: "none",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg"
                                                    }
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M16.01 11.2955H4V13.2955H16.01V16.2955L20 12.2955L16.01 8.29553V11.2955Z",
                                                        fill: "#F57483"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isCompletedOrCanceled &&
                            _vm.job.claim &&
                            _vm.job.claim.claim_status_id === 3
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "claim-resolved col-lg-12 col-12"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center justify-content-between h-100"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center w-100"
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  width: "32",
                                                  height: "25",
                                                  viewBox: "0 0 32 25",
                                                  fill: "none",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    "fill-rule": "evenodd",
                                                    "clip-rule": "evenodd",
                                                    d:
                                                      "M8 14.9381C6.89543 14.9381 6 15.8336 6 16.9381V18.9257C6 20.0303 6.89543 20.9257 8 20.9257H18.0224C18.0076 20.7614 18 20.595 18 20.4268C18 17.3955 20.4624 14.9381 23.5 14.9381C23.7284 14.9381 23.968 14.9403 24.2115 14.9492C24.142 14.9419 24.0714 14.9381 24 14.9381H23.5H8Z",
                                                    fill: "#2DB300"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("rect", {
                                                  attrs: {
                                                    x: "6.5",
                                                    y: "8.45259",
                                                    width: "19",
                                                    height: "4.98761",
                                                    rx: "1.5",
                                                    stroke: "#2DB300"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("rect", {
                                                  attrs: {
                                                    x: "6.5",
                                                    y: "1.46704",
                                                    width: "19",
                                                    height: "4.98761",
                                                    rx: "1.5",
                                                    stroke: "#2DB300"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    "fill-rule": "evenodd",
                                                    "clip-rule": "evenodd",
                                                    d:
                                                      "M23.5 15.9361C21.0187 15.9361 19 17.9506 19 20.4268C19 22.9029 21.0187 24.9175 23.5 24.9175C25.9813 24.9175 28 22.903 28 20.4268C28 17.9506 25.9813 15.9361 23.5 15.9361ZM22.8066 18.6744C22.8066 18.2922 23.1171 17.9824 23.5 17.9824C23.883 17.9824 24.1934 18.2922 24.1934 18.6744V20.4268C24.1934 20.809 23.883 21.1188 23.5 21.1188C23.1171 21.1188 22.8066 20.809 22.8066 20.4268V18.6744ZM24.1797 22.3935C24.1844 22.3713 24.1875 22.3487 24.1898 22.3261C24.1922 22.3035 24.1936 22.2809 24.1936 22.2583C24.1936 22.2357 24.1922 22.2127 24.1899 22.1901C24.1876 22.1679 24.1844 22.1453 24.1797 22.1232C24.1756 22.1011 24.1696 22.0789 24.1631 22.0572C24.1567 22.036 24.1488 22.0144 24.1405 21.9936C24.1317 21.9728 24.1219 21.9521 24.1114 21.9322C24.1007 21.9124 24.0892 21.893 24.0767 21.8741C24.0642 21.8552 24.0504 21.8367 24.036 21.8197C24.0217 21.8022 24.0065 21.7851 23.9903 21.7689C23.9746 21.7532 23.9575 21.7376 23.9399 21.7233C23.9223 21.709 23.9038 21.6956 23.8849 21.6831C23.8663 21.6707 23.8465 21.6587 23.8266 21.6481C23.8067 21.6375 23.7859 21.6278 23.7651 21.6195C23.7443 21.6107 23.7231 21.6029 23.7014 21.5964C23.6796 21.59 23.6579 21.5844 23.6357 21.5798C23.6135 21.5752 23.5908 21.5719 23.5682 21.5696C23.5229 21.565 23.4771 21.565 23.4319 21.5696C23.4097 21.572 23.3871 21.5752 23.3648 21.5798C23.3426 21.5844 23.3205 21.59 23.2987 21.5964C23.277 21.6029 23.2557 21.6107 23.235 21.6195C23.2141 21.6278 23.1933 21.6374 23.1735 21.6481C23.1535 21.6587 23.1341 21.6707 23.1152 21.6831C23.0963 21.6956 23.0777 21.709 23.0606 21.7233C23.0426 21.7375 23.026 21.7532 23.0098 21.7689C22.9936 21.785 22.9784 21.8021 22.964 21.8197C22.9497 21.8367 22.9363 21.8552 22.9238 21.8741C22.9108 21.893 22.8992 21.9124 22.8887 21.9322C22.878 21.9521 22.8683 21.9728 22.86 21.9936C22.8513 22.0144 22.8434 22.036 22.8369 22.0572C22.8305 22.0789 22.8249 22.1011 22.8203 22.1232C22.8156 22.1453 22.8124 22.1679 22.8101 22.1901C22.8078 22.2127 22.8068 22.2357 22.8068 22.2583C22.8068 22.2809 22.8077 22.3035 22.8101 22.3261C22.8124 22.3487 22.8156 22.3713 22.8203 22.3935C22.8249 22.4156 22.8305 22.4378 22.8369 22.459C22.8434 22.4807 22.8513 22.5019 22.86 22.5226C22.8683 22.5434 22.878 22.5642 22.8887 22.584C22.8993 22.6038 22.9108 22.6237 22.9238 22.6421C22.9363 22.661 22.9496 22.6795 22.964 22.697C22.9783 22.7145 22.9935 22.7316 23.0098 22.7473C23.0259 22.7635 23.0426 22.7786 23.0606 22.7934C23.0777 22.8073 23.0963 22.8211 23.1152 22.8336C23.1341 22.846 23.1535 22.8575 23.1735 22.8682C23.1933 22.8788 23.2141 22.8885 23.235 22.8972C23.2557 22.906 23.277 22.9134 23.2987 22.9198C23.3205 22.9268 23.3426 22.9323 23.3648 22.9364C23.387 22.9411 23.4097 22.9448 23.4319 22.9466C23.4545 22.9489 23.4776 22.9503 23.5002 22.9503C23.5229 22.9503 23.5455 22.9489 23.5682 22.9466C23.5908 22.9447 23.6135 22.941 23.6357 22.9364C23.6579 22.9323 23.6795 22.9267 23.7013 22.9198C23.723 22.9134 23.7443 22.906 23.7651 22.8972C23.7859 22.8885 23.8067 22.8788 23.8266 22.8682C23.8465 22.8575 23.8663 22.846 23.8848 22.8336C23.9038 22.8211 23.9222 22.8073 23.9399 22.7934C23.9574 22.7787 23.9745 22.7635 23.9902 22.7473C24.0064 22.7317 24.0216 22.7146 24.0359 22.697C24.0503 22.6795 24.0641 22.661 24.0767 22.6421C24.0892 22.6237 24.1007 22.6038 24.1113 22.584C24.1219 22.5642 24.1317 22.5434 24.1404 22.5226C24.1487 22.5019 24.1566 22.4807 24.163 22.459C24.1695 22.4378 24.1755 22.4156 24.1797 22.3935Z",
                                                    fill: "#2DB300"
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "pl-3 d-block claim-resolved-title text-truncate"
                                              },
                                              [
                                                _vm._v(
                                                  "Closed claim (" +
                                                    _vm._s(
                                                      _vm.job.claim
                                                        .claim_resolution
                                                    ) +
                                                    ") - " +
                                                    _vm._s(_vm.job.claim.title)
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: {
                                                path:
                                                  "/claims/edit/" +
                                                  _vm.job.claim.id
                                              },
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex pointer align-items-center justify-content-end"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "see-claim-resolved"
                                                  },
                                                  [_vm._v("See claim")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "svg",
                                                  {
                                                    staticClass:
                                                      "claim-resolved-icon pl-2",
                                                    attrs: {
                                                      width: "24",
                                                      height: "25",
                                                      viewBox: "0 0 24 25",
                                                      fill: "none",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg"
                                                    }
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M16.01 11.2955H4V13.2955H16.01V16.2955L20 12.2955L16.01 8.29553V11.2955Z",
                                                        fill: "#2DB300"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.job.status_id === 30 &&
                    _vm.job.claim &&
                    _vm.job.claim.id === null
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-content-start col-6" },
                          [
                            _c("div", { staticClass: "job-cancelled col-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-between h-100"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center w-100"
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg"
                                          }
                                        },
                                        [
                                          _c(
                                            "mask",
                                            {
                                              attrs: {
                                                id: "mask0",
                                                "mask-type": "alpha",
                                                maskUnits: "userSpaceOnUse",
                                                x: "0",
                                                y: "0",
                                                width: "24",
                                                height: "24"
                                              }
                                            },
                                            [
                                              _c("rect", {
                                                attrs: {
                                                  width: "24",
                                                  height: "24",
                                                  fill: "white"
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "g",
                                            { attrs: { mask: "url(#mask0)" } },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  "fill-rule": "evenodd",
                                                  "clip-rule": "evenodd",
                                                  d:
                                                    "M16.9125 8.42724L15.5727 7.08746L12 10.6602L8.42725 7.08746L7.08747 8.42724L10.6602 12L7.08747 15.5727L8.42725 16.9125L12 13.3398L15.5728 16.9125L16.9125 15.5727L13.3398 12L16.9125 8.42724Z",
                                                  fill: "#F57483"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  "fill-rule": "evenodd",
                                                  "clip-rule": "evenodd",
                                                  d:
                                                    "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
                                                  stroke: "#F57483"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "pl-3 job-cancelled-title"
                                        },
                                        [
                                          _vm._v(
                                            "Job cancelled " +
                                              _vm._s(
                                                _vm.job.cancellation_status_log
                                                  .note
                                                  ? "- " +
                                                    _vm.job
                                                      .cancellation_status_log
                                                      .note
                                                  : ""
                                              )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isCompletedOrCanceled &&
                    _vm.job.changes > 0 &&
                    !_vm.isInProgressTrackingOrPayment &&
                    _vm.job.status_id !== 21
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-content-start col-6" },
                          [
                            _c("div", { staticClass: "job-changes col-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-between h-100"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center w-100"
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "21",
                                            height: "18",
                                            viewBox: "0 0 21 18",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg"
                                          }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9C10 10.1 10.9 11 12 11C13.1 11 14 10.1 14 9ZM12 0C7.03 0 3 4.03 3 9H0L4 13L8 9H5C5 5.13 8.13 2 12 2C15.87 2 19 5.13 19 9C19 12.87 15.87 16 12 16C10.49 16 9.09 15.51 7.94 14.7L6.52 16.14C8.04 17.3 9.94 18 12 18C16.97 18 21 13.97 21 9C21 4.03 16.97 0 12 0Z",
                                              fill: "#2962FF"
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "pl-3 job-changes-title"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.job.changes) +
                                              " new updates for this job"
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          path: "/jobs/edit/" + _vm.job.id
                                        },
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex pointer align-items-center justify-content-end"
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "see-job-changes" },
                                            [_vm._v("See details")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "job-changes-icon pl-2",
                                              attrs: {
                                                width: "24",
                                                height: "25",
                                                viewBox: "0 0 24 25",
                                                fill: "none",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M16.01 11.2955H4V13.2955H16.01V16.2955L20 12.2955L16.01 8.29553V11.2955Z",
                                                  fill: "#2962FF"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isInProgressTrackingOrPayment
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-content-start col-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "movers-working col-12" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center justify-content-between h-100"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center w-100"
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "22",
                                              height: "16",
                                              viewBox: "0 0 22 16",
                                              fill: "none",
                                              xmlns:
                                                "http://www.w3.org/2000/svg"
                                            }
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d:
                                                  "M19 4H16V0H2C0.9 0 0 0.9 0 2V13H2C2 14.66 3.34 16 5 16C6.66 16 8 14.66 8 13H14C14 14.66 15.34 16 17 16C18.66 16 20 14.66 20 13H22V8L19 4ZM5 14.5C4.17 14.5 3.5 13.83 3.5 13C3.5 12.17 4.17 11.5 5 11.5C5.83 11.5 6.5 12.17 6.5 13C6.5 13.83 5.83 14.5 5 14.5ZM18.5 5.5L20.46 8H16V5.5H18.5ZM17 14.5C16.17 14.5 15.5 13.83 15.5 13C15.5 12.17 16.17 11.5 17 11.5C17.83 11.5 18.5 12.17 18.5 13C18.5 13.83 17.83 14.5 17 14.5Z",
                                                fill: "#5B30EC"
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "pl-3 movers-working-title"
                                          },
                                          [
                                            _vm._v(
                                              "Movers are currently working on this job."
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            path: "/jobs/edit/" + _vm.job.id
                                          },
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex pointer align-items-center justify-content-end"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "see-movers-working"
                                              },
                                              [_vm._v("See details")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "svg",
                                              {
                                                staticClass:
                                                  "movers-working-icon pl-2",
                                                attrs: {
                                                  width: "24",
                                                  height: "25",
                                                  viewBox: "0 0 24 25",
                                                  fill: "5B30EC",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "M16.01 11.2955H4V13.2955H16.01V16.2955L20 12.2955L16.01 8.29553V11.2955Z",
                                                    fill: "#2962FF"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.job.status_id === 21
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-content-start col-6" },
                          [
                            _c("div", { staticClass: "job-on-hold col-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-between h-100"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center w-100"
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg"
                                          }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.89 22 12 22ZM18 16V11C18 7.93 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.63 5.36 6 7.93 6 11V16L4 18V19H20V18L18 16ZM14.5 9.8L11.7 13.2H14.5V15H9.5V13.2L12.3 9.8H9.5V8H14.5V9.8Z",
                                              fill: "#FFAB00"
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "pl-3 job-on-hold-title"
                                        },
                                        [_vm._v("Job on hold")]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-center col-6"
                      },
                      [
                        _c("div", { staticClass: "col-6" }, [
                          _vm.job.ratings && _vm.job.ratings[0]
                            ? _c(
                                "span",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c("div", { staticClass: "mr-2" }, [
                                    _vm._v(
                                      _vm._s(_vm.job.ratings[0].diff_for_humans)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("star-rating", {
                                    attrs: {
                                      rating: _vm.job.ratings[0].rating,
                                      "star-size": 15,
                                      "show-rating": false,
                                      increment: 0.1,
                                      "read-only": true
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.job.status_id === 16
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-end col-6 pr-0"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-12 col-12 d-flex flex-column justify-content-end align-items-end pr-0"
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "total-price-text" },
                                      [_vm._v("Total price")]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "job-price" }, [
                                      _vm._v("$" + _vm._s(_vm.job.price))
                                    ])
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _vm.showCarrierReassignModal
              ? _c(
                  "modal",
                  {
                    attrs: { size: "modal-large" },
                    on: { close: _vm.closeReassignCarrierModal }
                  },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("h4", [_vm._v("Assign carrier")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { slot: "body" }, slot: "body" },
                      [
                        _vm.job.carrier
                          ? _c("p", [
                              _vm._v(
                                "\n          Changing carrier will remove all movers and trucks from this move.\n        "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("div", { staticClass: "form-row" }, [
                              _c("div", {
                                staticClass:
                                  "col-4 text-right pt-2 pl-0 cc-n-umber radio-button-wrap ml-3"
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "row col-md-8" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-3 d-flex align-items-center justify-content-center"
                                  },
                                  [
                                    _c(
                                      "small",
                                      { staticClass: "text-secondary" },
                                      [_vm._v("Movers AM")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-3 d-flex align-items-center justify-content-center"
                                  },
                                  [
                                    _c(
                                      "small",
                                      { staticClass: "text-secondary" },
                                      [_vm._v("Movers PM")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-3 d-flex align-items-center justify-content-center"
                                  },
                                  [
                                    _c(
                                      "small",
                                      { staticClass: "text-secondary" },
                                      [_vm._v("Trucks AM")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-3 d-flex align-items-center justify-content-center"
                                  },
                                  [
                                    _c(
                                      "small",
                                      { staticClass: "text-secondary" },
                                      [_vm._v("Trucks PM")]
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.carriersForAssign, function(carrier) {
                              return _c(
                                "div",
                                {
                                  key: carrier.id,
                                  staticClass: "form-row",
                                  class: {
                                    "radio-border-blue":
                                      _vm.carrierId === carrier.id
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.setCarrier(carrier.id, carrier.name)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-4 text-right pt-2 pl-0 cc-n-umber radio-button-wrap ml-3"
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "pointer text-left w-100 h-100 d-flex align-items-center"
                                        },
                                        [
                                          _c("input", {
                                            attrs: {
                                              type: "radio",
                                              id: "carrier-" + carrier.id
                                            },
                                            domProps: {
                                              checked:
                                                _vm.carrierId === carrier.id
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "btn-radio"
                                          }),
                                          _vm._v(" "),
                                          _c("label", {
                                            staticClass: "btn-radio-label",
                                            attrs: {
                                              for: "carrier-" + carrier.id
                                            },
                                            domProps: {
                                              textContent: _vm._s(carrier.name)
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row col-md-8" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-3 d-flex align-items-center justify-content-center"
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "btn-status btn-amount",
                                          class: [
                                            _vm.giveStyleAssignCarrierAvailability(
                                              carrier,
                                              "movers",
                                              "am"
                                            )
                                          ],
                                          domProps: {
                                            textContent: _vm._s(
                                              carrier.available_movers_am +
                                                " / " +
                                                carrier.total_movers
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-3 d-flex align-items-center justify-content-center"
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "btn-status btn-amount",
                                          class: [
                                            _vm.giveStyleAssignCarrierAvailability(
                                              carrier,
                                              "movers",
                                              "pm"
                                            )
                                          ],
                                          domProps: {
                                            textContent: _vm._s(
                                              carrier.available_movers_pm +
                                                " / " +
                                                carrier.total_movers
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-3 d-flex align-items-center justify-content-center"
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "btn-status btn-amount",
                                          class: [
                                            _vm.giveStyleAssignCarrierAvailability(
                                              carrier,
                                              "trucks",
                                              "am"
                                            )
                                          ],
                                          domProps: {
                                            textContent: _vm._s(
                                              carrier.available_trucks_am +
                                                " / " +
                                                carrier.total_trucks
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-3 d-flex align-items-center justify-content-center"
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "btn-status btn-amount",
                                          class: [
                                            _vm.giveStyleAssignCarrierAvailability(
                                              carrier,
                                              "movers",
                                              "pm"
                                            )
                                          ],
                                          domProps: {
                                            textContent: _vm._s(
                                              carrier.available_trucks_pm +
                                                " / " +
                                                carrier.total_trucks
                                            )
                                          }
                                        })
                                      ]
                                    )
                                  ])
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: "availability" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 text-center" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              attrs: { type: "button" },
                              on: { click: _vm.closeReassignCarrierModal }
                            },
                            [_vm._v("Discard")]
                          ),
                          _vm._v(" "),
                          _c("button", {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            domProps: {
                              textContent: _vm._s(
                                _vm.job.carrier ? "Reassign" : "Assign"
                              )
                            },
                            on: { click: _vm.reassignCarrier }
                          })
                        ])
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showModalAcceptJob
              ? _c(
                  "modal",
                  {
                    on: {
                      close: function($event) {
                        _vm.showModalAcceptJob = false
                      }
                    }
                  },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("h4", { staticClass: "pb-2" }, [
                        _vm._v(_vm._s(_vm.job.ref_id) + " - Accept job")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                      _c("div", { staticClass: "row mb-2" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("div", [
                            _c("p", { staticClass: "mb-1" }, [
                              _vm._v("\n                Move "),
                              _c("b", [_vm._v(_vm._s(_vm.job.ref_id))]),
                              _vm._v(" was marked as  "),
                              _vm.job.is_small === 1
                                ? _c("span", [_vm._v("a")])
                                : _c("span", [_vm._v("an")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.isSmallJob) +
                                  ",\n                "
                              ),
                              _vm.job.is_small === 1
                                ? _c("span", [
                                    _vm._v("deselect if it is a all day job.")
                                  ])
                                : _c("span", [
                                    _vm._v("select it if its a small job.")
                                  ])
                            ]),
                            _c("div", { staticClass: "customer-check-field" }, [
                              _c("span", { staticClass: "customer-checkmark" }),
                              _vm._v(
                                "\n                Small job\n                "
                              ),
                              _c("input", {
                                attrs: { type: "checkbox" },
                                domProps: {
                                  value: _vm.job.is_small,
                                  checked: _vm.job.is_small === 1
                                },
                                on: { change: _vm.changeSmallJob }
                              })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 text-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.showModalAcceptJob = false
                                }
                              }
                            },
                            [_vm._v("Discard")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              on: {
                                click: function($event) {
                                  _vm.changeStatus(_vm.job.id, 3)
                                }
                              }
                            },
                            [_vm._v("Accept")]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showModalCancelJob
              ? _c(
                  "modal",
                  {
                    on: {
                      close: function($event) {
                        _vm.showModalCancelJob = false
                      }
                    }
                  },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("h4", [
                        _vm._v(_vm._s(_vm.job.ref_id) + " - Cancellation note")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                      _c("div", { staticClass: "row mb-2" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("div", { staticClass: "select-wrap h-auto" }, [
                              _c("label", [_vm._v("Note")]),
                              _vm._v(" "),
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.note,
                                    expression: "note"
                                  }
                                ],
                                staticClass:
                                  "select-wrap-textarea form-control",
                                attrs: { rows: "5" },
                                domProps: { value: _vm.note },
                                on: {
                                  keydown: function($event) {
                                    _vm.clearError($event)
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.note = $event.target.value
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: { errors: _vm.errors, field: "note" }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 text-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.showModalCancelJob = false
                                }
                              }
                            },
                            [_vm._v("Discard")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              on: {
                                click: function($event) {
                                  _vm.changeStatus(_vm.job.id, 30)
                                }
                              }
                            },
                            [_vm._v("Proceed")]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showModalRejectJob
              ? _c(
                  "modal",
                  {
                    on: {
                      close: function($event) {
                        _vm.showModalRejectJob = false
                      }
                    }
                  },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("h4", { staticClass: "pb-2" }, [
                        _vm._v(_vm._s(_vm.job.ref_id) + " - Rejection note")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                      _c("div", { staticClass: "row mb-2" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("p", { staticClass: "mb-1" }, [
                            _vm._v("\n              Move "),
                            _c("b", [_vm._v(_vm._s(_vm.job.ref_id))]),
                            _vm._v(" was marked as "),
                            _vm.job.is_small === 1
                              ? _c("span", [_vm._v("a")])
                              : _c("span", [_vm._v("an")]),
                            _vm._v(
                              " " + _vm._s(_vm.isSmallJob) + ",\n              "
                            ),
                            _vm.job.is_small === 1
                              ? _c("span", [
                                  _vm._v("deselect it for an all day job.")
                                ])
                              : _c("span", [
                                  _vm._v("select it for a small job.")
                                ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "customer-check-field pb-3" },
                            [
                              _c("span", { staticClass: "customer-checkmark" }),
                              _vm._v(
                                "\n              Small job\n              "
                              ),
                              _c("input", {
                                attrs: { type: "checkbox" },
                                domProps: {
                                  value: _vm.job.is_small,
                                  checked: _vm.job.is_small === 1
                                },
                                on: { change: _vm.changeSmallJob }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "select-wrap h-auto mt-3" },
                            [
                              _c("label", [_vm._v("Note")]),
                              _vm._v(" "),
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.note,
                                    expression: "note"
                                  }
                                ],
                                staticClass:
                                  "select-wrap-textarea form-control",
                                attrs: { rows: "5" },
                                domProps: { value: _vm.note },
                                on: {
                                  keydown: function($event) {
                                    _vm.clearError($event)
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.note = $event.target.value
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 text-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.showModalRejectJob = false
                                }
                              }
                            },
                            [_vm._v("Discard")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              on: {
                                click: function($event) {
                                  _vm.changeStatus(_vm.job.id, 31)
                                }
                              }
                            },
                            [_vm._v("Proceed")]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showModalIsSmallJob
              ? _c(
                  "modal",
                  {
                    on: {
                      close: function($event) {
                        _vm.showModalIsSmallJob = false
                      }
                    }
                  },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("h4", { staticClass: "pb-2" }, [
                        _vm._v(_vm._s(_vm.job.ref_id) + " - Job size")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                      _c("div", { staticClass: "row mb-2" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("div", [
                            _c("p", { staticClass: "mb-1" }, [
                              _vm._v("\n                Move "),
                              _c("b", [_vm._v(_vm._s(_vm.job.ref_id))]),
                              _vm._v(" was marked as  "),
                              _vm.job.is_small === 1
                                ? _c("span", [_vm._v("a")])
                                : _c("span", [_vm._v("an")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.isSmallJob) +
                                  ",\n                "
                              ),
                              _vm.job.is_small === 1
                                ? _c("span", [
                                    _vm._v("deselect if it is a all day job.")
                                  ])
                                : _c("span", [
                                    _vm._v("select it if its a small job.")
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "customer-check-field" }, [
                              _c("span", { staticClass: "customer-checkmark" }),
                              _vm._v(
                                "\n                Small job\n                "
                              ),
                              _c("input", {
                                attrs: { type: "checkbox" },
                                domProps: {
                                  value: _vm.job.is_small,
                                  checked: _vm.job.is_small === 1
                                },
                                on: { change: _vm.changeSmallJob }
                              })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 text-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "button" },
                              on: { click: _vm.save }
                            },
                            [_vm._v("Save")]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showUserReassignModal
              ? _c(
                  "modal",
                  {
                    attrs: { size: "modal-large", "close-strict": true },
                    on: {
                      close: function($event) {
                        _vm.showUserReassignModal = false
                      }
                    }
                  },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-10" }, [
                          _c("div", [
                            _c("h4", [
                              _vm._v(
                                _vm._s(_vm.job.ref_id) +
                                  " - Select user to assign job to"
                              )
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { slot: "body" }, slot: "body" },
                      [
                        _c(
                          "div",
                          { staticClass: "select-wrap" },
                          [
                            _c("label", [_vm._v("Select User")]),
                            _vm._v(" "),
                            _c("simple-select", {
                              attrs: { options: _vm.assignees },
                              on: {
                                change: function($event) {
                                  _vm.clearError($event)
                                }
                              },
                              model: {
                                value: _vm.assigneeId,
                                callback: function($$v) {
                                  _vm.assigneeId = $$v
                                },
                                expression: "assigneeId"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: {
                            errors: _vm.errors,
                            field: "cluster_user_id"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary pull-right",
                              attrs: { type: "button" },
                              on: { click: _vm.reassignUser }
                            },
                            [_vm._v("\n              Reassign\n            ")]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.cashCollectModal
              ? _c(
                  "modal",
                  {
                    attrs: { size: "modal-large", "close-strict": false },
                    on: {
                      close: function($event) {
                        _vm.cashCollectModal = false
                      }
                    }
                  },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      !_vm.job.cash_collected
                        ? _c("h4", [
                            _vm._v("\n          Cash collect\n        ")
                          ])
                        : _c("h4", [
                            _vm._v("\n          Cash not collected\n        ")
                          ])
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          !_vm.job.cash_collected
                            ? [
                                _vm._v(
                                  "\n            This will mark that the cash was collected for this job. Do you want to proceed?\n          "
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n            This will mark that the cash was not collected for this job. Do you want to proceed?\n          "
                                )
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-center mt-3",
                          staticStyle: { gap: "15px" }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.cashCollectModal = false
                                }
                              }
                            },
                            [_vm._v("No")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "button" },
                              on: { click: _vm.setCashCollected }
                            },
                            [_vm._v("Yes")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                      _c("div", {
                        staticClass:
                          "d-flex align-items-center justify-content-end w-100"
                      })
                    ])
                  ]
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ellipsis px-4 py-4" }, [
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a4c0e4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a4c0e4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobsBlock.vue
// module id = null
// module chunks = 